import { useState } from "react";
import { Code, Check, Copy } from "@phosphor-icons/react";

// A copy-paste embed snippet any SocialPulse site can drop onto a page.
export default function EmbedSnippet({ entityType, entityId, title }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const origin = window.location.origin;
  const src = `${origin}/embed/context?entity_type=${entityType}&entity_id=${entityId}&limit=8`;
  const snippet = `<iframe src="${src}"\n  title="PhotoPulse — ${title || entityId}"\n  style="width:100%;border:0;min-height:420px" loading="lazy"></iframe>`;

  const copy = async () => {
    try { await navigator.clipboard.writeText(snippet); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch { /* */ }
  };

  return (
    <div className="mt-8 rounded-3xl border border-[#E5DFD3] bg-[#FFF8EE] p-5" data-testid="embed-snippet">
      <button onClick={() => setOpen((o) => !o)} data-testid="embed-toggle" className="flex w-full items-center justify-between text-left">
        <span className="flex items-center gap-2 font-display font-bold text-[#2C2724]"><Code size={18} weight="bold" className="text-[#F27A54]" /> Embed this feed on your site</span>
        <span className="text-xs font-semibold text-[#787167]">{open ? "Hide" : "Show snippet"}</span>
      </button>
      {open && (
        <div className="mt-3">
          <pre data-testid="embed-code" className="overflow-x-auto rounded-xl bg-[#2C2724] p-3.5 text-[11px] leading-relaxed text-[#FFD8C2]"><code>{snippet}</code></pre>
          <button onClick={copy} data-testid="embed-copy" className="mt-2 flex items-center gap-1.5 rounded-full bg-[#2D6A4F] px-4 py-2 text-xs font-bold text-white hover:bg-[#245840]">
            {copied ? <Check size={14} weight="bold" /> : <Copy size={14} weight="bold" />} {copied ? "Copied" : "Copy code"}
          </button>
          <p className="mt-2 text-xs text-[#787167]">Paste anywhere. It shows only photos approved for public use, with attribution back to PhotoPulse.</p>
        </div>
      )}
    </div>
  );
}
